<template>
  <v-theme-provider :dark="dark">
        <v-col
          v-if="title || subtitle"
          cols="12"
          md="3"
          sm="12"
        >
          <base-subtitle
            v-if="subtitle"
            :title="subtitle"
            space="1"
          />

          <base-title
            class="text-uppercase"
            space="1"
          >
          <a
          @click="changeTab(to)"
          >
            {{ title }}
          </a>
          </base-title>
          <base-divider :color="color" />
          <base-body
          space="6"
          v-if="text"
          v-text="text"
          >
          </base-body>
        </v-col>
  </v-theme-provider>
</template>

<script>
  // Mixins
  import Heading from '@/mixins/heading'

  export default {
    name: 'BaseInfoCol',

    mixins: [Heading],

    props: {
      features: [],
      dark: Boolean,
      callout: String,
      extlink: String,
      color: {
        type: String,
        default: 'primary',
      },
      icon: String,
      subtitle: String,
      text: String,
      title: String,
      to: String,
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      changeTab (to) {
        if (this.isMobileDevice()) {
          window.location.href = 'https://cas.polito.it/ETS23/#/' + to
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        } else {
          document.getElementById(to).click()
        }
      },
    },
  }
</script>
